<template>
  <admin-layout>
    <template slot="content">
      <header-for-list-component
          sectionName="Clientes"
          :items="customers"
          :totalItems="totalItems"
          :totalPages="totalPages"
          :itemsPerPage="itemsPerPage"
          :pageNumber.sync="pageNumber"
          @loadPage="loadPage($event)"
      />

      <v-layout
          align-center
          justify-space-between
          class="mb-3"
      >
        <v-flex xs4>
          <v-text-field
              v-model="search"
              solo
              label="Buscar por Cliente"
              prepend-inner-icon="mdi-magnify"
              hide-details
              :loading="loadingSearch"
              @input="typing()"
          >
            <template v-slot:progress>
              <v-progress-linear
                  v-if="loadingSearch"
                  color="accent"
                  indeterminate
                  height="3"
              ></v-progress-linear>
            </template>
          </v-text-field>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex
            xs4
            class="text-xs-right">
          <create-or-update
              mode="create"
              :customer="null"
              @loadPage="loadPage(pageNumber)"
          ></create-or-update>
        </v-flex>
      </v-layout>
      <v-layout column>
        <v-data-table
            :headers="headers"
            :items="customers"
            hide-actions
            class="elevation-1">
          <template slot="items" slot-scope="props">
            <td>{{ props.item.id }}</td>
            <td>{{ props.item.name }}</td>
            <td class="text-xs-center">{{ cpf.format(props.item.cpf) }}</td>
            <td>{{ props.item.email }}</td>
            <td class="text-xs-center">
              <v-icon> mdi-{{ props.item.confirmed_at === null ? 'checkbox-blank-outline' : 'checkbox-marked' }}</v-icon>
            </td>
            <td>
              <v-layout row>
                <create-or-update
                    mode="edit"
                    :customer="Object.assign({}, props.item)"
                    @loadPage="loadPage(pageNumber)">
                </create-or-update>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      v-on="on"
                      v-if="!props.item.confirmed_at"
                      @click="resendConfirmationInstructions(props.item)"
                    >
                      <v-icon small>mdi-email-send-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Reenviar email para confirmar conta</span>
                </v-tooltip>
              </v-layout>
            </td>
          </template>
        </v-data-table>
      </v-layout>
    </template>
  </admin-layout>
</template>

<script>
import AdminLayout from '@/layouts/AdminLayout';
import HeaderForListComponent from '@/components/configurations/HeaderForListComponent';
import CustomerService from '@/services/applications/configurations/CustomerService';

import CreateOrUpdate from '@/components/configurations/customers/CreateOrUpdate';

import * as cpf from "@fnando/cpf";
export default {
  name: 'List',
  components: {
    AdminLayout,
    HeaderForListComponent,
    CreateOrUpdate,
  },
  mounted() {
    this.loadPage(1);
  },
  data() {
    return {
      cpf,
      search: '',
      customers: [],
      loadingSearch: false,
      interval: null,
      totalItems: 0,
      totalPages: 0,
      itemsPerPage: 20,
      pageNumber: 1,
      headers: [
        { text: 'ID', value: 'id', sortable: false, align: 'center' },
        { text: 'Nome', value: 'name', sortable: false, align: 'center' },
        { text: 'CPF', value: 'cpf', sortable: false, align: 'center' },
        { text: 'E-mail', value: 'email', sortable: false, align: 'center' },
        { text: 'Confirmado', value: 'enabled', sortable: false, align: 'center' },
        { text: 'Ações', value: '', sortable: false, align: 'center' }],
    };
  },
  methods: {
    loadPage(pageNumber) {
      this.pageNumber = pageNumber || this.pageNumber;
      if (!this.loadingSearch) this.$store.dispatch('setLoadingDialog', true);
      CustomerService
        .all({
          page: this.pageNumber,
          q: this.search,
        })
        .then(({ data }) => {
          this.customers = data.customers || [];
          this.totalItems = data.total;
          this.totalPages = data.total_pages;
        })
        .finally(() => {
          this.$store.dispatch('setLoadingDialog', false);
          this.loadingSearch = false;
        });
    },
    resendConfirmationInstructions(item) {
      this.$store.dispatch('setLoadingDialog', true);
      CustomerService
        .resendConfirmationInstructions(item.id)
        .then(() => {
          this.$swal({
            title: 'Email enviado',
            type: 'success',
            confirmButtonText: 'Ok',
          });
        })
        .catch(() => {
          this.$swal({
            title: 'Ocorreu um erro ao enviar email',
            text: 'Tente novamente mais tarde',
            type: 'error',
          });
        })
        .finally(() => {
          this.$store.dispatch('setLoadingDialog', false);
        })
    },
    typing() {
      clearInterval(this.interval)
      this.interval = setTimeout(() => {
        this.loadingSearch = true;
        this.pageNumber = 1;
        this.loadPage();
      }, 500);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
